import { Select } from "components/Form";
import React from "react";
import { useIntl } from "react-intl";
export function ProductPackSelector({ product, onChange }) {
    const intl = useIntl();
    return (React.createElement(Select, { label: "", defaultLabel: intl.formatMessage({ id: `Choisissez votre quantité de`, defaultMessage: `Choisissez votre quantité de` }) + ' ' + product.name, returnKey: false, name: "element", valueKey: "_id", displayKey: "name", className: "pack-selector", onChange: onChange, options: product.elements }));
}
